import AppHome from "@views/app/app-home.vue";
import { dashboardRoutes } from "@/app/router/dashboard/dashboard-routes";
import { seznamNakupovRoutes } from "@/app/router/user-contract-list/user-contract-list-routes";
import { predracunRoutes } from "@/app/router/pro-forma-payment/pro-forma-payment-routes";
import { informacijeRoutes } from "@/app/router/information/information-routes";
import { informativeCalculationRoutes } from "./informative-calculation/informative-calculation-routes";
import { IzracunLimitaRoutes } from "./limit-calculation/limit-calculation-routes";
import { nastavitveRoutes } from "./settings/settings-routes";
import { kontaktRoutes } from "./contact/contact-routes";

export const appRoutes = [
    {
        children: [
            ...dashboardRoutes,
            ...seznamNakupovRoutes,
            ...predracunRoutes,
            ...informacijeRoutes,
            ...informativeCalculationRoutes,
            ...IzracunLimitaRoutes,
            ...nastavitveRoutes,
            ...kontaktRoutes,
            ],
        component: AppHome,
        name: "app_home",
        path: "",
        redirect:  { name: "dashboard_dashboard" }, // this is the default home view
    },
];